(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3Accept', sc3Accept);

    sc3Accept.$inject = [];
    function sc3Accept() {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attr) {
            scope.$watch(attr.sc3Accept, sc3AcceptWatchAction);
            
            function sc3AcceptWatchAction(value) {
                attr.$set('accept', value);
            }
        }
    }
})();
